'use client';

import Image from 'next/image';
import { useState } from 'react';

import { trackEvent } from '@/libs/analytics/events';

interface MyCardItemProps {
  metadataIdx: number;
  cardName: string;
  image: string;
  isSelected: boolean;
  onSelect: (metadataIdx: number, cardName: string, image: string) => void;
}

export default function MyCardItem({ metadataIdx, cardName, image, isSelected, onSelect }: MyCardItemProps) {
  const [isImageLoading, setIsImageLoading] = useState(true);

  return (
    <button
      type="button"
      onClick={() => {
        trackEvent({ name: 'set_rep_card', params: { card_name: cardName, card_idx: metadataIdx } });
        onSelect(metadataIdx, cardName, image);
      }}
      className="flex w-[65px] cursor-pointer flex-col items-center"
    >
      <div className="relative h-[100px] w-[65px] overflow-hidden rounded">
        {isImageLoading && <div className="absolute inset-0 animate-pulse bg-white/10" />}
        <Image
          src={image}
          alt={cardName}
          fill
          className="object-cover"
          sizes="65px"
          onLoad={() => setIsImageLoading(false)}
        />

        {/* Selected overlay */}
        {isSelected && (
          <div className="gradient-border absolute inset-0 flex items-center justify-center rounded bg-black/80 gradient-border-card-deco-selected">
            <span className="text-gradient text-center typo-caption-2 whitespace-pre-line text-gradient-card-deco-selected">
              {'대표카드\n선택'}
            </span>
          </div>
        )}
      </div>
      <p className="mt-2 w-full truncate text-center typo-caption-1 text-white">{cardName}</p>
    </button>
  );
}
